interface PastPaperInfo {
  date?: string | null;
  subject?: string | null;
  paper_number?: string | null;
}

/**
 * Formats a past paper title with subject, paper number, month and year
 * @param paper - The paper data with date, subject, and paper_number
 * @returns Formatted title like "English Language Paper 1 - May 2024"
 */
export const formatPastPaperTitle = (paper: PastPaperInfo | string | null | undefined): string => {
  // Handle legacy usage where just a date string is passed
  if (typeof paper === 'string' || paper === null || paper === undefined) {
    const date = paper;
    const baseTitle = 'English Language Paper 1';
    if (!date) return baseTitle;

    try {
      const dateObj = new Date(date);
      const month = dateObj.toLocaleString('en-US', { month: 'long' });
      const year = dateObj.getFullYear();
      return `${baseTitle} - ${month} ${year}`;
    } catch {
      return baseTitle;
    }
  }

  // New usage: full paper object
  const subject = paper.subject || 'English Language';
  const paperNum = paper.paper_number || 'Paper 1';
  const baseTitle = `${subject} ${paperNum}`;

  if (!paper.date) return baseTitle;

  try {
    const dateObj = new Date(paper.date);
    const month = dateObj.toLocaleString('en-US', { month: 'long' });
    const year = dateObj.getFullYear();
    return `${baseTitle} - ${month} ${year}`;
  } catch {
    return baseTitle;
  }
};
